import React from 'react';
import Svg from '../Svg';

const IconSpeedometer03 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 6C8.68629 6 6 8.68629 6 12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12C4 7.58172 7.58172 4 12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6ZM17.207 6.79289C17.5975 7.18342 17.5975 7.81658 17.207 8.20711L13.9322 11.4819C13.9764 11.6471 14 11.8208 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C12.1791 10 12.3528 10.0236 12.518 10.0677L15.7928 6.79289C16.1833 6.40237 16.8165 6.40237 17.207 6.79289Z"
    />
  </Svg>
);

export default IconSpeedometer03;
